import React from 'react';
import { Image, Platform, View } from 'react-native';
import { useIMGElementProps } from 'react-native-render-html';
import { parseNodeStyles } from '../helper';

const cleanDimension = dimension => dimension.replaceAll('pt', '').replaceAll('px', '').replaceAll('pt', '');

const trimObjectPropNames = obj => Object.entries(obj).reduce((result, [key, value]) => {
    result[key?.trim()] = value;
    return result;
}, {});

const ImageRenderer = ({ TDefaultRenderer, ...props }) => {
    const imageElementProps = useIMGElementProps(props);
    const nodeStyles = parseNodeStyles(props?.tnode?.attributes?.style);
    const specifiedHeight = props?.tnode?.attributes?.height || trimObjectPropNames(nodeStyles)?.height;
    const specifiedWidth = props?.tnode?.attributes?.width || trimObjectPropNames(nodeStyles)?.width;
    const imageSource = imageElementProps.source?.uri?.replaceAll('about://', 'https://');

    if (!specifiedHeight && !specifiedWidth) {
        return null;
    }

    const actualHeight = !specifiedHeight ? cleanDimension(specifiedWidth) : cleanDimension(specifiedHeight);
    const actualWidth = !specifiedWidth ? cleanDimension(specifiedHeight) : cleanDimension(specifiedWidth);
    const percentageBased = actualHeight.indexOf('%') !== -1 || actualWidth.indexOf('%') !== -1;

    if (Platform.OS.equals('web')) {
        return <img width={actualWidth} src={imageSource} style={{ display: 'flex', alignSelf: 'center' }} />;
    }

    return (
        <View style={{ alignItems: 'center' }}>
            <Image
                resizeMode='contain'
                source={{uri: imageSource}}
                style={{
                    height: percentageBased ? actualHeight : parseInt(actualHeight),
                    width: percentageBased ? actualWidth : parseInt(actualWidth)
                }}
            />
        </View>
    );
};

export default ImageRenderer;
